import { render, staticRenderFns } from "./TicketFilter.vue?vue&type=template&id=1006c01b&"
import script from "./TicketFilter.vue?vue&type=script&lang=ts&"
export * from "./TicketFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports